export function pad2(n: number) { return n < 10 ? `0${n}` : String(n); }

export function toIsoLocal(d: Date) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

// Bez parsowania ISO jako UTC:
export function ymdToDate(ymd: string) {
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(y, m - 1, d); // lokalnie
}

export function addDaysISO(ymd: string, days: number) {
  const [y, m, d] = ymd.split("-").map(Number);
  const dt = new Date(y, m - 1, d + days);
  return toIsoLocal(dt);
}

export function monthBounds(yyyyMM: string) {
  const [y, m] = yyyyMM.split("-").map(Number);
  const first = new Date(y, m - 1, 1);
  const last  = new Date(y, m, 0);
  return { df: toIsoLocal(first), dt: toIsoLocal(last) };
}
